import React, { useState, useEffect, Fragment } from "react";
import { Box, Button, Typography, Grid, MenuItem, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams, useOutletContext } from "react-router-dom";
import MpgItem from "../../../../CommonFormComp/MpgItem";
import { useGetSignedInUserDetails } from "../../../../hooksAndFunctions/customHooks/useGetSignedInUserDetails";
import { clientAccPDViewPath } from "../../../../routes/routePaths";
import MpgLoadingDialog from "../../../../common/dialog/MpgLoadingDialog";
import MpgErrorDialog from "../../../../common/dialog/MpgErrorDialog";
import { useGetLoggedInUserDetails } from "../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import { useCreateOrUpdateFolderStructureForPDsMutation, useGetFolderStructureForPDsByClientAccIdQuery } from "../../../../reactQueries/AppApi/rqHooksForClientAccProgrammeDescriptor";
import FolderTreeStructureComp from "./folderTree/FolderTreeStructureComp";
import { resourceSortWindowsFormat } from "../../../../hooksAndFunctions/functions/resourceSortWindowsFormat";

const ViewResourceFolderStructure = ({ clientAccPDDetailsById }) => {
  const navigate = useNavigate();

  const { loggedInUser } = useGetLoggedInUserDetails();
  const { emailAddress } = loggedInUser;

  const rhfFormInstance = useForm();

  const clientAccountId = clientAccPDDetailsById?.ClientAccountId
  const clientAccountName = clientAccPDDetailsById?.ClientAccountName

  /** !!!!!!!! API calls  !!!!!!!! */
  // api - create report resource mutation
  const {
    mutate: createOnFolderStructureForPDs,
    isError: isErrorOnFolderStructureForPDs,
    isLoading: isLoadingOnFolderStructureForPDs,
    isSuccess: isSuccessOnFolderStructureForPDs,
    data: dataOnFolderStructureForPDs,
    error: errorOnFolderStructureForPDs,
  } = useCreateOrUpdateFolderStructureForPDsMutation();

  const {
    data: folderData,
    isError: isErrorOnFolderData,
    isFetching: isFetchingOnFolderData,
    isSuccess: isSuccessOnFolderData,
    error: errorOnFolderData,
  } = useGetFolderStructureForPDsByClientAccIdQuery({ clientAccountId });


  const rootFolderData = folderData?.RootFolder
  const resourceFolders = rootFolderData?.ResourceFolders || []

  // console.log("rootFolderData:", folderData)
  /**
   * root folder details getting managed seperately
   * {
        Id:"",
        ResourceRootName:"",
        ProgramDescriptors:[],
      }
   */
  const [rootFolderObject, setRootFolderObject] = useState({})
  /**set rootFolderObject details from get API */
  useEffect(() => {
    if (!!rootFolderData?.Id) {
      
      rootFolderData?.ProgramDescriptors?.sort(windowsSortForProgramDescriptor);
      setRootFolderObject({
        Id: rootFolderData?.Id || "",
        ResourceRootName: rootFolderData?.ResourceRootName || "",
        ProgramDescriptors: rootFolderData?.ProgramDescriptors || [],
      })
    }
  }, [rootFolderData])

  const [compositeFolderArrayInsideRoot, setCompositeFolderArrayInsideRoot] = useState([])

  useEffect(() => {
    if (!!resourceFolders && !!resourceFolders.length) {      
      resourceFolders.sort(windowsSortForResourceFolder);
      setCompositeFolderArrayInsideRoot([...resourceFolders])
    }
  }, [resourceFolders])

  
  // Usage for folders:
  function windowsSortForResourceFolder(a, b) {
    return resourceSortWindowsFormat(a, b, 'ResourceFolderName');
  }

  // Usage for program descriptors:
  function windowsSortForProgramDescriptor(a, b) {
    return resourceSortWindowsFormat(a, b, 'ProgramDescripitorTitle');
  }

  // console.log("compositeFolderArrayInsideRoot12345", compositeFolderArrayInsideRoot)

  /** !!!!!!!! handling submit function  !!!!!!!! */

  const onSubmit = (data) => {

    /**
     * if IsNewlyAdded and IsDeleted both are true then we can remove that item from our body
     */
    /** */

    // console.log("compositeFolderArrayInsideRoot12345", compositeFolderArrayInsideRoot)

    /** firstly excluding newlyAdded and deleted folders */
    let excludedFolders = []

    /** this contain folders excluding all those folders with  IsNewlyAdded=true and IsDeleted=true */
    let remainingFolders = []

    !!compositeFolderArrayInsideRoot && compositeFolderArrayInsideRoot.filter((eachFolder) => {

      if (!!eachFolder?.IsNewlyAdded && !!eachFolder?.IsDeleted) {
        excludedFolders.push(eachFolder)
      } else {

        const subFolderList = eachFolder?.ResourceSubFolders

        let excludedSubFolders = []

        /** this contain subfolders excluding all those subfolders with  IsNewlyAdded=true and IsDeleted=true */
        let remainingSubFolders = []

        !!subFolderList && subFolderList.forEach((eachSubFolder) => {
          if (!!eachSubFolder?.IsNewlyAdded && !!eachSubFolder?.IsDeleted) {
            excludedSubFolders.push(eachSubFolder)
          } else {
            if (!!eachSubFolder?.IsNewlyAdded) {
              remainingSubFolders.push({
                ...eachSubFolder,
                Id: "00000000-0000-0000-0000-000000000000"
              })
            } else {
              remainingSubFolders.push(eachSubFolder)
            }
          }
        })

        if (!!eachFolder?.IsNewlyAdded) {
          remainingFolders.push({
            ...eachFolder,
            Id: "00000000-0000-0000-0000-000000000000",
            ResourceSubFolders: remainingSubFolders || []
          })
        } else {
          remainingFolders.push({
            ...eachFolder,
            ResourceSubFolders: remainingSubFolders || []
          })
        }
      }
    })

    const body = {
      // ...folderData,
      ClientAccountId: clientAccountId,
      ClientAccountName: clientAccountName,
      /**Id -> this Id is Id of RootFolder */
      Id: !!rootFolderData?.Id ? rootFolderData?.Id : "00000000-0000-0000-0000-000000000000",
      RootProgramDescriptors: rootFolderObject?.ProgramDescriptors || [],
      ResourceFolders: remainingFolders || [],
      // RootFolder: {
      //   ...folderData.RootFolder,
      //   ResourceFolders: remainingFolders || []
      // }
      CreatedBy: !rootFolderData?.Id ? emailAddress : ""
    }

    // console.log("body:", body)

    createOnFolderStructureForPDs({
      body
    })
  };

  const resourcesCMSData = useOutletContext();

  const fetchClientAccResDtlsLabel = (key) => {
    if (resourcesCMSData && resourcesCMSData?.pageContent["ClientAccountResourcesDetails"]) {
      const resourcesCMSDataLabel = resourcesCMSData.pageContent["ClientAccountResourcesDetails"];
      return returnLabel(resourcesCMSDataLabel?.Labels, key)
    }
  }

  const fetchCommonCMSLabel = (key) => {
    if (resourcesCMSData && resourcesCMSData?.pageContent["CommonComponent"]) {
        const commonCMSDataLabel = resourcesCMSData.pageContent["CommonComponent"];
        return returnLabel(commonCMSDataLabel?.Labels, key)
    }
    return '';
  }

  const returnLabel = (labelArray, key) => {
    if (labelArray.length > 0 && key) {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }
    return '';
  }

  useEffect(() => {
    if (!!isSuccessOnFolderStructureForPDs) {
      navigate(clientAccPDViewPath);
    }
  }, [isSuccessOnFolderStructureForPDs]);


  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h5" align="center" sx={{ fontWeight: "bolder" }}>
        {/* Manage Resource Folders for Client */}
        {`${fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ManageResourceFolder')} "${clientAccountName}"`} 
      </Typography>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        m={1}
      >
        <Button
          variant="outlined"
          size="small"
          component={Link}
          to={clientAccPDViewPath}
        >
          {/* Client Account - Programme Descriptors */}
          {fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ClientAccountProgramDescriptor')}
        </Button>
      </Stack>

      <Box
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={rhfFormInstance.handleSubmit(onSubmit)}
      >

        <MpgItem>

          <FolderTreeStructureComp
            folderDataByClientAccId={folderData}
            pdDataByClientAccId={clientAccPDDetailsById}

            rootFolderObject={rootFolderObject}
            setRootFolderObject={setRootFolderObject}

            compositeFolderArrayInsideRoot={compositeFolderArrayInsideRoot}
            setCompositeFolderArrayInsideRoot={setCompositeFolderArrayInsideRoot}
          />
        </MpgItem>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-evenly"}
          mt={3}
        >
          <Button variant="outlined" type="submit" size="small">
            {fetchCommonCMSLabel("Common.Update")}
          </Button>
        </Stack>
      </Box>

      {/** error dialog on create action */}
      <MpgErrorDialog
        open={!!errorOnFolderStructureForPDs}
      />

      <MpgLoadingDialog
        open={
          !!isLoadingOnFolderStructureForPDs
        }
      />
    </Box >
  );
};

export default ViewResourceFolderStructure;
